import { Navigate } from "react-router-dom";

const Register = () => <Navigate to="/login?view=register" replace />;

export default Register;
